<template>
  <el-container class="page-task-filter-list-container">
    <el-header>
      <!-- <Header></Header> -->
    </el-header>
    <el-main>
      <div class="back" @click="$router.go(-1)">
        <span class="el-icon-arrow-left"></span>
        <span>返回</span>
      </div>
      <div class="study-detail">
        <!-- 预览问卷 -->
        <div class="study-left">
          <div class="label-box">
            <span class="one"></span>
            <span class="study-label">随访问卷</span>
            <span class="study-label" v-if="qsStatus">({{ qsStatus }})</span>
            <span class="label-box-refresh" @click="refreshQ" style="margin-left:50px;"><i class="el-icon-refresh"></i>刷新</span>
          </div>
          <div style="padding-left: 15px;padding-right:15px;padding-top: 10px;">
            <question-tree-node :questionId="$route.query.taskId" :followUpWay="$route.query.followUpWay" v-if="update"
                                ref="questionTreeNode"
            ></question-tree-node>
          </div>

        </div>
        <!-- 学习材料 -->
        <div class="study-right ">
          <div class="label-box">
            <span class="one"></span>
            <span class="study-label" @click="showArticleDetail = false">随访材料</span>
            <el-select clearable @change="selectFloderHandler" size="mini" v-model="selectFloder">
              <el-option :label="item.folderName" :value="item.fileFolderId" v-for="(item,index) in floderList"
                         :key="item.fileFolderId"></el-option>
            </el-select>
            <div v-if="showArticleDetail" style="text-decoration:underline;" @click="showArticleDetail = false">
              <span class="el-icon-arrow-right" style="font-weight: bold"></span>
              <span class="two">{{ studyContent.title }}</span>
              <span class="el-icon-circle-close" style="font-weight: bold"></span>
            </div>
          </div>
          <div class="study-list" v-show="!showArticleDetail">
            <div
                @click="previewHandler(item)"
                v-for="(item, index) in fileList"
                :key="index"
                class="article-item"
            >
              <span style="color:#000;font-size:15px;">{{ item.fileName }} <span v-if="item.showDot"
                                                                                 style="color: red;font-size: 16px;font-weight: 700;margin-left: 15px;">新</span></span>
              <span class="el-icon-arrow-right"></span>
            </div>
          </div>

          <div class="article-detail ql-container" v-show="showArticleDetail">
            <div
                id="studyPage"
                style="min-height: 350px"
                v-html="studyContent.content"
            ></div>
          </div>
          <div class="preview-dialog">
            <previewFileDialog :fullScreen="true" :title="'预览'" v-model="previewDialogVisible">
              <div v-if="previewStuff == 'office'" style="height: 86vh;" slot="pv">
                <iframe
                    :src='previewSrc'
                    width='100%' height='100%'>
                </iframe>
              </div>
              <div v-else-if="previewStuff == 'pdf'" style="height: 86vh;" slot="pv">
                <iframe
                    :src='previewSrc'
                    width='100%' height='100%'>
                </iframe>
              </div>
              <div v-else-if="previewStuff == 'audio'" style="height: 86vh;" slot="pv">
                <video autoplay controls style="width: 100%;height: 100%;" :src="previewSrc"></video>
              </div>
              <div style="text-align: center" v-else-if="previewStuff == 'pic'" slot="pv">
                <img v-viewer="{movable: true}" :src="previewSrc" alt="" style="width: 400px;">
              </div>
            </previewFileDialog>
          </div>
        </div>

        <div class="preview-dialog">
          <previewFileDialog :fullScreen="true" :title="'预览'" v-model="previewDialogVisible">
            <div v-if="previewStuff == 'office'" style="height: 86vh;" slot="pv">
              <iframe
                  :src='previewSrc'
                  width='100%' height='100%'>
              </iframe>
            </div>
            <div v-else-if="previewStuff == 'pdf'" style="height: 86vh;" slot="pv">
              <iframe
                  :src='previewSrc'
                  width='100%' height='100%'>
              </iframe>
            </div>
            <div v-else-if="previewStuff == 'video'" style="height: 86vh;" slot="pv">
              <video autoplay controls style="width: 100%;height: 100%;" :src="previewSrc"></video>
            </div>
            <div v-else-if="previewStuff == 'audio'" style="height: 86vh;" slot="pv">
              <audio autoplay controls style="width: 100%;height: 100%;" :src="previewSrc"></audio>
            </div>
            <div style="text-align: center" v-else-if="previewStuff == 'pic'" slot="pv">
              <img v-viewer="{movable: true}" :src="previewSrc" alt="" style="width: 400px;">
            </div>
          </previewFileDialog>
        </div>
      </div>
    </el-main>

  </el-container>
</template>
<script type="text/ecmascript-6">
import Header from "../common/Header";
import Footer from "../common/Footer";
import questionTreeNode from "../study/question-root-node";
import previewFileDialog from '@/components/previewFileDialog'

import {mapGetters, mapMutations, mapState} from "vuex";
import {
  RestNewFollowupQuestionListServicePreviewTask,
  RestNewFollowupCallCenterServiceGetStudyListByTask,
  RestNewFollowupCallCenterServiceGetStudyById,
  RestNewFollowupQuestionListServicePreviewQuestionnaire
} from "@src/assets/js/api.js";

export default {
  name: "task-container",
  data() {
    return {
      previewDialogVisible: false,
      previewStuff: "",
      previewSrc: "",
      selectFloder: "",
      qsStatus: "",
      studyList: [],
      fileList: [],
      floderList: [],
      showArticleDetail: false,
      studyContent: {},
      studyTitle: "",
      update: true
    };
  },
  components: {
    Header,
    Footer,
    questionTreeNode,
    previewFileDialog,
  },
  props: {
    tableData: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters(["userid", "questionId"]),
    ...mapState([
      'user'
    ])
  },
  mounted() {
    this.onload();
    this.getFolderList({
      flag: 1
    })
    this.getFileList({
      folderId: null,
      flag: 2,
    }).then(res => {
      this.fileList = res.retValue
    })
  },
  methods: {
    ...mapMutations(["setTaskCenterId", "setTaskType", "setQuestion"]),
    goToPage(page, taskId) {
      localStorage.setItem("taskId", taskId);
      this.$router.push({
        path: `/${page}`,
      });
    },
    onload() {
      this.getTabelList();
      this.getQuestionByPageAndId()
      this.previewTask()
    },
    previewHandler(params) {
      let office = ['.pptx', '.ppt', '.doc', '.docx', '.xls', '.xlsx',]
      let video = ['.mp4', '.avi', '.mpg', '.mpeg', '.mov', '.wmv']
      let audio = ['.mp3','.wav','.wma','.flac','.midi','.mov']
      this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetPreviewFileUrl',
        params: {
          fileId: params.id
        }
      }).then((res) => {
        this.previewStuff = params.fileSuffix
        if (office.indexOf(params.fileSuffix) != -1) {
          this.previewSrc = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(res.retValue)}&wdOrigin=BROWSELINK`
          this.previewStuff = 'office'
        } else if (params.fileSuffix == '.pdf') {
          this.previewSrc = `${res.retValue}`
          this.previewStuff = 'pdf'
        } else if (video.indexOf(params.fileSuffix) != -1) {
          this.previewSrc = `${res.retValue}`
          this.previewStuff = 'video'
        } else if (audio.indexOf(params.fileSuffix) != -1) {
          this.previewSrc = `${res.retValue}`
          this.previewStuff = 'audio'
        } else {
          this.previewSrc = `${res.retValue}`
          this.previewStuff = 'pic'
        }
        this.previewDialogVisible = true
      })
    },

    selectFloderHandler(val) {
      this.getFileList({
        folderId: val,
        flag: 2,
      }).then(res => {
        this.fileList = res.retValue
      })
    },
    getTabelList() {
      var vm = this;
      this.getStudyListByTaskAsync({taskId: this.$route.query.taskId}).then(
          (res) => {
            vm.studyList = res.retValue;
          }
      );
    },
    getFolderList(p) {
      this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetFolderNameList',
        params: {
          followUpTaskId: this.$route.query.taskId,
          flag: p.flag
        }
      }).then(res => {
        console.log(res);
        this.floderList = res.retValue
      })
    },
    async getFileList(p) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetFileListByTaskId',
        params: {
          folderId: p.folderId,
          flag: p.flag,
          taskId: this.$route.query.taskId
        }
      })
      return result
    },
    async previewTask() {
      let request = new RestNewFollowupQuestionListServicePreviewTask()
      request.p_taskId = this.$route.query.taskId;
      request.p_nowUserId = sessionStorage.getItem('userid')
      await request.send()
    },
    async getQuestionByPageAndId(p) {
      var vm = this
      let request = new RestNewFollowupQuestionListServicePreviewQuestionnaire()
      request.p_followUpType = this.$route.query.followUpWay;
      request.p_pageNumber = 1;
      request.p_taskId = this.$route.query.taskId;
      await request.send()
      if (request.result.retValue.status == 1) {
        return vm.qsStatus = "编辑中"
      } else {
        return vm.qsStatus = "已发布"
      }


    },
    getStudyById(item) {
      this.getStudyByIdAsync({
        studyId: item.studyId,
      }).then((res) => {
        this.studyTitle = item;
        this.studyContent = res.retValue;
        this.showArticleDetail = true;
        setTimeout(() => {
          this.watermark()
        })
      });
    },
    watermark(settings) {
      //默认设置
      var defaultSettings = {
        watermark_txt: `上海荟医信息科技有限公司 坐席号：${this.user.userid}`,
        watermark_x: 20, //水印起始位置x轴坐标
        watermark_y: 20, //水印起始位置Y轴坐标
        watermark_rows: 20, //水印行数
        watermark_cols: 20, //水印列数
        watermark_x_space: 50, //水印x轴间隔
        watermark_y_space: 50, //水印y轴间隔
        watermark_color: '#aaa', //水印字体颜色
        watermark_alpha: 0.4, //水印透明度
        watermark_fontsize: '15px', //水印字体大小
        watermark_font: '微软雅黑', //水印字体
        watermark_width: 180, //水印宽度
        watermark_height: 80, //水印长度
        watermark_angle: 20 //水印倾斜度数
      };
      if (arguments.length === 1 && typeof arguments[0] === "object") {
        var src = arguments[0] || {};
        for (key in src) {
          if (src[key] && defaultSettings[key] && src[key] === defaultSettings[key]) continue;
          else if (src[key]) defaultSettings[key] = src[key];
        }
      }
      var oTemp = document.createDocumentFragment();
      let element = document.getElementById('studyPage')
      console.log(element);
      //获取页面最大宽度
      var page_width = Math.max(element.scrollWidth, element.clientWidth);
      var cutWidth = page_width * 0.0150;
      var page_width = page_width - cutWidth;
      //获取页面最大高度
      var page_height = Math.max(element.scrollHeight, element.clientHeight) + 450;
      page_height = Math.max(page_height, window.innerHeight - 30);
      //如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
      if (defaultSettings.watermark_cols == 0 || (parseInt(defaultSettings.watermark_x + defaultSettings.watermark_width * defaultSettings.watermark_cols + defaultSettings.watermark_x_space * (defaultSettings.watermark_cols - 1)) > page_width)) {
        defaultSettings.watermark_cols = parseInt((page_width - defaultSettings.watermark_x + defaultSettings.watermark_x_space) / (defaultSettings.watermark_width + defaultSettings.watermark_x_space));
        defaultSettings.watermark_x_space = parseInt((page_width - defaultSettings.watermark_x - defaultSettings.watermark_width * defaultSettings.watermark_cols) / (defaultSettings.watermark_cols - 1));
      }
      //如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
      if (defaultSettings.watermark_rows == 0 || (parseInt(defaultSettings.watermark_y + defaultSettings.watermark_height * defaultSettings.watermark_rows + defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)) > page_height)) {
        defaultSettings.watermark_rows = parseInt((defaultSettings.watermark_y_space + page_height - defaultSettings.watermark_y) / (defaultSettings.watermark_height + defaultSettings.watermark_y_space));
        defaultSettings.watermark_y_space = parseInt(((page_height - defaultSettings.watermark_y) - defaultSettings.watermark_height * defaultSettings.watermark_rows) / (defaultSettings.watermark_rows - 1));
      }
      var x;
      var y;
      for (var i = 0; i < defaultSettings.watermark_rows; i++) {
        y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i;
        for (var j = 0; j < defaultSettings.watermark_cols; j++) {
          x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j;
          var mask_div = document.createElement('div');
          mask_div.id = 'mask_div' + i + j;
          mask_div.className = 'mask_div';
          mask_div.appendChild(document.createTextNode(defaultSettings.watermark_txt));
          //设置水印div倾斜显示
          mask_div.style.webkitTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
          mask_div.style.MozTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
          mask_div.style.msTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
          mask_div.style.OTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
          mask_div.style.transform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
          mask_div.style.visibility = "";
          mask_div.style.position = "absolute";
          mask_div.style.left = x + 'px';
          mask_div.style.top = y + 'px';
          mask_div.style.overflow = "hidden";
          mask_div.style.zIndex = "9999";
          //让水印不遮挡页面的点击事件
          mask_div.style.pointerEvents = 'none';
          mask_div.style.opacity = defaultSettings.watermark_alpha;
          mask_div.style.fontSize = defaultSettings.watermark_fontsize;
          mask_div.style.fontFamily = defaultSettings.watermark_font;
          mask_div.style.color = defaultSettings.watermark_color;
          mask_div.style.textAlign = "center";
          mask_div.style.width = defaultSettings.watermark_width + 'px';
          mask_div.style.height = defaultSettings.watermark_height + 'px';
          mask_div.style.display = "block";
          oTemp.appendChild(mask_div);
        }
        ;
      }
      ;
      element.appendChild(oTemp);
    },
    // 刷新（清空）问卷
    refreshQ() {
      this.update = false
      this.$nextTick(() => {
        this.update = true
      })
    },

    async getStudyListByTaskAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetStudyListByTask();
      request.p_taskId = p.taskId;
      request.p_isAdd = true;
      await request.send();
      return request.result;
    },
    async getStudyByIdAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetStudyById();
      request.p_studyId = p.studyId;
      await request.send();
      return request.result;
    },
  },
};
</script>
<style lang="scss">
.study-detail {
  .question {
    height: 75vh !important;
  }
}
</style>
<style scoped lang="scss">
.el-main {
  background-color: rgb(250, 250, 250);
}

.back {
  height: 30px;
  display: flex;
  align-items: center;
  color: #248cfa;
  font-weight: bold;
  margin-top: 10px;
  cursor: pointer;
}

.study-detail {
  padding: 0 20px;
  display: flex;
  justify-content: space-around;

  .label-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;
    cursor: pointer;
    position: relative;

    .one {
      width: 5px;
      background-color: #248cfa;
      height: 20px;
      margin-left: 10px;
      margin-right: 8px;
    }

    &-refresh {
      position: absolute;
      right: 30px;
      color: #248cfa;
      border-bottom: 1px solid #248cfa;
    }
  }

  .study-label {
    font-size: 18px;
    font-weight: bold;

  }

  .study-left {
    margin-top: 15px;
    height: calc(100vh - 160px);
    overflow: scroll;
    width: 49%;
    background-color: #fff;
  }

  .study-right {
    margin-top: 15px;
    width: 49%;
    background-color: #fff;
    height: calc(100vh - 160px);

    .article-detail {
      // min-height: 600px;
      // height: 760px;
      overflow: scroll;
      padding: 15px;
    }

    .study-list {
      padding-left: 10px;
      padding-right: 10px;
      height: 720px;
      //height: 770px;
      overflow: scroll;

      .article-item {
        display: flex;
        justify-content: space-between;
        height: 40px;
        cursor: pointer;
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1)
      }
    }
  }
}
</style>
